export default {
  dateSelection(state) {
    return state.dateSelection;
  },
};
